import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Mission from './components/Mission';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

const App: React.FC = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'mission','skills', 'projects',  'contact'];
      const scrollPosition = window.scrollY + 100;

      // Show scroll-to-top button after scrolling past viewport height
      setShowScrollTop(window.scrollY > window.innerHeight);

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ThemeProvider>
      <div className="App">
        <Header activeSection={activeSection} />
        
        <main>
          <Hero />
          <Mission />
          <Skills />
          <Projects />       
          <Contact />
        </main>
        
        <Footer />
        
        {/* Scroll Progress Indicator */}
        <div className="scroll-progress" style={{ transform: `scaleX(0)` }} />

        {/* Scroll to Top Button */}
        <AnimatePresence>
          {showScrollTop && (
            <motion.button
              className="floating-scroll-to-top"
              onClick={scrollToTop}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 0.7, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              whileHover={{ opacity: 1, scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}
              title="Retour en haut"
            >
              <i className="fas fa-chevron-up"></i>
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </ThemeProvider>
  );
};

export default App;